import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useDisconnectedNetworksStore } from '@/stores/disconnectedNetworksStore';

export function useDisconnectedNetworks(userId: string | undefined) {
  const {
    loading,
    fetchDisconnectedNetworks,
    getDisconnectedNetworks
  } = useDisconnectedNetworksStore();

  useEffect(() => {
    if (!userId) {
      return;
    }

    fetchDisconnectedNetworks(userId);

    const subscription = supabase
      .channel('disconnected_networks_check')
      .on('postgres_changes', 
        { event: '*', schema: 'public', table: 'social_connections', filter: `user_id=eq.${userId}` },
        () => fetchDisconnectedNetworks(userId)
      )
      .on('postgres_changes',
        { event: '*', schema: 'public', table: 'video_content', filter: `user_id=eq.${userId}` },
        () => fetchDisconnectedNetworks(userId)
      )
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, [userId, fetchDisconnectedNetworks]);

  return { 
    disconnectedNetworks: userId ? getDisconnectedNetworks(userId) : [], 
    isLoading: userId ? (loading[userId] ?? true) : false 
  };
}
